import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusPipeline = ({ stats }) => {
  const stages = [
    {
      id: 'processing',
      label: 'Procesando',
      icon: 'Clock',
      color: 'info',
      count: stats?.processing || 0
    },
    {
      id: 'packed',
      label: 'Empaquetado',
      icon: 'Package',
      color: 'warning',
      count: stats?.packed || 0
    },
    {
      id: 'shipped',
      label: 'Enviado',
      icon: 'Send',
      color: 'primary',
      count: stats?.shipped || 0
    },
    {
      id: 'in_transit',
      label: 'En tránsito',
      icon: 'Truck',
      color: 'secondary',
      count: stats?.in_transit || 0
    },
    {
      id: 'delivered',
      label: 'Entregado',
      icon: 'CheckCircle',
      color: 'success',
      count: stats?.delivered || 0
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      info: 'bg-info-100 text-info border-info-200',
      warning: 'bg-warning-100 text-warning border-warning-200',
      primary: 'bg-primary-100 text-primary border-primary-200',
      secondary: 'bg-secondary-100 text-secondary border-secondary-200',
      success: 'bg-success-100 text-success border-success-200'
    };
    return colors[color] || colors.primary;
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-heading-semibold text-text-primary">
          Estado de Pedidos
        </h2>
        <div className="text-sm text-text-muted">
          {new Date().toLocaleDateString('es-ES', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4">
        {stages.map((stage, index) => (
          <div key={stage.id} className="flex-1">
            <div className="flex items-center space-x-3">
              {/* Stage Icon and Info */}
              <div className={`
                flex items-center justify-center w-12 h-12 rounded-lg border-2 
                ${getColorClasses(stage.color)}
              `}>
                <Icon name={stage.icon} size={20} strokeWidth={2} />
              </div>
              
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-body-medium text-text-primary">
                    {stage.label}
                  </h3>
                  <span className="text-lg font-heading-semibold text-text-primary">
                    {stage.count}
                  </span>
                </div>
                <p className="text-xs text-text-muted">
                  {stage.count === 1 ? 'pedido' : 'pedidos'}
                </p>
              </div>

              {/* Connector Line */}
              {index < stages.length - 1 && (
                <div className="hidden lg:block w-8 h-px bg-border ml-4"></div>
              )}
            </div>

            {/* Mobile Connector */}
            {index < stages.length - 1 && (
              <div className="lg:hidden flex justify-center mt-2 mb-2">
                <div className="w-px h-4 bg-border"></div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Summary Stats */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="text-center">
            <div className="text-lg font-heading-semibold text-text-primary">
              {Object.values(stats || {}).reduce((a, b) => a + b, 0)}
            </div>
            <div className="text-xs text-text-muted">Total de pedidos</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-heading-semibold text-warning">
              {(stats?.processing || 0) + (stats?.packed || 0)}
            </div>
            <div className="text-xs text-text-muted">Pendientes</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-heading-semibold text-primary">
              {(stats?.shipped || 0) + (stats?.in_transit || 0)}
            </div>
            <div className="text-xs text-text-muted">En curso</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-heading-semibold text-success">
              {Math.round(((stats?.delivered || 0) / Object.values(stats || {}).reduce((a, b) => a + b, 1)) * 100)}%
            </div>
            <div className="text-xs text-text-muted">Tasa de entrega</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusPipeline;